import {
  AppBar,
  IconButton,
  Toolbar,
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import Container from "@mui/material/Container";
import UserProfilesService from "../../Libs/Services/UserProfiles.service";

interface IProps {
  onCloseHandler: () => void;
}

export function NewPassword(props: IProps) {
  const [inputs, setInputs] = useState({
    password: "",
    showPassword: false,
  });

  //--------------------------------------------------//
  //--------------------------------------------------//
  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleClickShowPassword = () => {
    setInputs({
      ...inputs,
      showPassword: !inputs.showPassword,
    });
  };

  const updateHandler = () => {
    UserProfilesService.updatePassword(localStorage.email, inputs.password)
    props.onCloseHandler();
  }

  //--------------------------------------------------//
  //--------------------------------------------------//
  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={props.onCloseHandler}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <div style={{ flex: 1 }}></div>
          <Button autoFocus color="inherit" onClick={updateHandler}>
            UPDATE
          </Button>
        </Toolbar>
      </AppBar>

      <div style={{ display: "flex", flex: 1, alignItems: "center" }}>
        <Container component="main" maxWidth="xs">
          <Box component="form" noValidate autoComplete="off">
            <FormControl variant="outlined" fullWidth focused>
              <FormHelperText>New Password*</FormHelperText>
              <OutlinedInput
                id="outlined-size-password"
                name="password"
                type={inputs.showPassword ? "text" : "password"}
                value={inputs.password || ""}
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                      color="primary"
                    >
                      {inputs.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
        </Container>
      </div>
    </>
  );
}
